import { Component, computed, DestroyRef, inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
// import { SUB_STATUS } from '@core/models/admin/admin-account.types';
import { AccountService } from '@core/services/admin/account.service';
import { SubscriptionService } from '@core/services/admin/subscription.service';
import { BillingService } from '@features/settings/billing/services/billing.service';
import { SETTINGS_SLUGS } from '@routes/routes.types';
import { SidebarComponent } from '../sidebar/sidebar.component';

import { TrialExpiredModalComponent } from '@features/settings/billing/components/trial-expired-modal/trial-expired-modal.component';
import { AgentChatPanelComponent } from '@features/agent-chat/components/agent-chat-panel/agent-chat-panel.component';
import { AgentChatSettingsComponent } from '@features/agent-chat/components/agent-chat-settings/agent-chat-settings.component';
import { VoiceCallBarComponent } from '@features/voice/components/voice-call-bar/voice-call-bar.component';
import { VoiceIncomingCallComponent } from '@features/voice/components/voice-incoming-call/voice-incoming-call.component';
import { VoiceQueueWidgetComponent } from '@features/voice/components/voice-queue-widget/voice-queue-widget.component';
import { VoiceShellService } from '@features/voice/services/voice-shell.service';
import { TopbarComponent } from '../topbar/topbar.component';

@Component({
    selector: 'app-main-content',
    imports: [
        RouterModule,
        SidebarComponent,
        TopbarComponent,
        TrialExpiredModalComponent,
        AgentChatPanelComponent,
        AgentChatSettingsComponent,
        VoiceCallBarComponent,
        VoiceQueueWidgetComponent,
        VoiceIncomingCallComponent,
    ],
    templateUrl: './main-content.component.html',
    styles: [':host {display: flex; flex-direction: column; flex: 1 1 0; overflow: hidden}'],
})
export class MainContentComponent implements OnInit {
    readonly accS = inject(AccountService);
    readonly subS = inject(SubscriptionService);
    private readonly billingS = inject(BillingService);
    private readonly router = inject(Router);

    private readonly isInCheckout = signal(false);
    private readonly isInSubscribePage = signal(false);

    readonly isTrialExpired = this.billingS.periodEndExpired;
    readonly showTrialExpiredModal = computed(
        () => this.isTrialExpired() && !this.isInSubscribePage()
    );

    constructor() {
        // Voice shell for the whole desktop session: the call feed stays connected and an
        // incoming call rings on every route, not only inside the inbox.
        inject(VoiceShellService).start(inject(DestroyRef));
    }

    ngOnInit() {
        this.checkUrl();
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.checkUrl();
            }
        });
    }

    private checkUrl() {
        const url = this.router.url;
        this.isInCheckout.set(url.includes(SETTINGS_SLUGS.checkout));
        this.isInSubscribePage.set(url.includes('settings/billing/subscribe'));
    }
}
